export default __webpack_public_path__ + "static/2025-real-time-data-4b8b68babfd5440b6feea2a80cc18ff0.jpg";